export default __webpack_public_path__ + "static/media/deactivate-inquiry.59ee310d.svg";